// Telnyx WebRTC client removed during Twilio migration.
// This client-side WebRTC helper must be replaced with a Twilio-based
// implementation (e.g. Twilio Client / Programmable Voice + Media Streams).
import toast from 'react-hot-toast';

// Optional howler import for ringtone
let Howl = null;
try {
    const howlerModule = require('howler');
    Howl = howlerModule.Howl || howlerModule.default?.Howl || howlerModule;
} catch (e) {
    // howler not installed - ringtone will be disabled
}

let client = null;
let activeCall = null;
let ringing = null;
const listeners = new Map();

function emit(event, data) {
    listeners.forEach(fn => fn(event, data));
}

export function subscribe(id, fn) {
    listeners.set(id, fn);
}

export function unsubscribe(id) {
    listeners.delete(id);
}

export function initWebRTC({ username, password }) {
    if (!username || !password) {
        toast.error('WebRTC credentials not configured');
        return;
    }

    // Don't reinitialize if already connected
    if (client) {
        // WebRTC client already initialized
        return client;
    }

    // Initialize ringtone only if howler is available
    if (Howl) {
        try {
            ringing = new Howl({ src: ['/ringtone.mp3'], loop: true });
        } catch (e) {
            console.warn('Failed to initialize ringtone:', e);
        }
    }

    // Telnyx implementation removed. Show an informative toast so developers
    // know this client-side WebRTC path still needs a Twilio-based implementation.
    toast.error('Telnyx WebRTC client removed. Implement a Twilio-based client here.');

    return client;
}

export function hangup() {
    if (activeCall) {
        activeCall.hangup();
    }
}

export function toggleMute(muted) {
    if (activeCall) {
        activeCall.setAudioMuted(muted);
    }
}

export function getActiveCall() {
    return activeCall;
}

export function getRemoteStream() {
    if (activeCall) {
        try {
            if (typeof activeCall.getRemoteStream === 'function') {
                return activeCall.getRemoteStream();
            }
            if (activeCall.remoteStream) {
                return activeCall.remoteStream;
            }
        } catch (e) {
            console.warn('Could not get remote stream:', e);
        }
    }
    return null;
}
